module.exports = __webpack_public_path__ + "static/media/trace.7a70c926.png";